import NavbarFooter from "../components/Footer";

import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/about")({
  component: RouteComponent,
});

function RouteComponent() {
  return <NavbarFooter />;
}
